import {
    Checkbox,
    FormControlLabel,
    Grid2,
    TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { UserTypeEnum } from "../../../_common/enum/userType.enum";
import EnumSelect from "../../../_components/autocomplete/enum.select";
import { StandardButton } from "../../../_components/button/primary.button";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { accountService } from "../../../_services/accounts.service";
import { ticketQueryService } from "../../../_services/ticketQuery.service";

export function TicketQueryManage(params: { onSave?(): void, onClose?(): void }) {

    const resetData = () => ({});
    const navigate = useNavigate();

    const { id, ticketType, queryId } = useParams<{ id: string, ticketType?: string, queryId?: string }>();
    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(true);
    const [saving, setIsSaving] = useState(false);

    useEffect(() => {
        if (id != null) fetchData();
        else setData(resetData);
    }, [id, queryId]);

    function fetchData() {
        if (!queryId) {
            setIsLoading(false);
            return;
        };

        setIsLoading(true);
        return ticketQueryService
            .get(queryId || "0")
            .then(
                (json) => {
                    setData(json);

                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const _data = { ...data, ticketId: id };

        return ticketQueryService
            .submit(_data)
            .then(
                () => {
                    toastr.success("Saved successfully");



                    if (!!params.onSave)
                        params.onSave();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (

        <ValidatorForm onSubmit={submit} noValidate style={{ padding: "4px" }}>
            <Grid2 container spacing={2}>

                {(accountService.isAdmin || accountService.isUser) &&
                    <Grid2 size={{ xs: 12 }}>
                        <EnumSelect
                            enumObject={UserTypeEnum}
                            label="Select User Type"
                            name="UserTypeId"
                            value={data.userTypeId}
                            onChange={handleChange}
                            disabled={queryId != null}
                            required />
                    </Grid2>
                }
                <Grid2 size={{ xs: 12 }}>
                    <StandardTextValidator
                        name="question"
                        label="Question"
                        fullWidth
                        multiline
                        value={data.question}
                        onChange={handleChange}
                        disabled={queryId != null}
                    />
                </Grid2>
                {!!queryId && (accountService.isAdmin || accountService.isUser) &&
                    <Grid2 size={{ xs: 12 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!data.isResolved}
                                    onChange={(e) =>
                                        setData((_data: any) => ({
                                            ..._data, isResolved: e.target.checked
                                        }))
                                    }
                                    name="isResolved"
                                />
                            }
                            label="Mark Resolved"
                        />
                    </Grid2>
                }

                {/*{!!queryId && <>*/}
                {/*    <Grid2 size={{ xs: 12 }}>*/}
                {/*        <StandardTextValidator*/}
                {/*            name="answer"*/}
                {/*            label="Answer"*/}
                {/*            fullWidth*/}
                {/*            multiline*/}
                {/*            rows={3}*/}
                {/*            value={data.answer}*/}
                {/*            onChange={handleChange}*/}
                {/*        />*/}
                {/*    </Grid2>*/}

                {/*    <Grid2 size={{ xs: 12 }}>*/}
                {/*        <TextField*/}
                {/*            name="history"*/}
                {/*            label="Answer History"*/}
                {/*            fullWidth*/}
                {/*            multiline*/}
                {/*            rows={15}*/}
                {/*            disabled*/}
                {/*            value={data.history}*/}
                {/*            InputLabelProps={{ shrink: true }}*/}
                {/*        />*/}
                {/*    </Grid2>*/}
                {/*</>}*/}

                <Grid2 size={{ xs: 6 }}>
                    <StandardButton
                        saving={saving}
                        loading={isLoading}
                        icon="save"
                        type="submit"
                    >
                        Save
                    </StandardButton>

                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                    <StandardButton
                        saving={saving}
                        loading={isLoading}
                        icon="block"
                        variant="error"
                        onClick={() => { navigate(-1) }}>
                        Cancel
                    </StandardButton>
                </Grid2>
            </Grid2>
        </ValidatorForm>

    );
}
